// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see MarketingProductHeroClickLearnMoreEvent
 */
export var MarketingProductHeroClickLearnMore = function (_a) {
    var href = _a.href;
    return ({
        name: "MarketingProductHero Click LearnMore",
        parameters: {
            cdf_entity: "MarketingProductHero",
            cdf_action: "Click",
            href: href !== undefined && href !== null ? href.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
